// extracted by mini-css-extract-plugin
export default {"base":"base-layout_base__htPHD","signupHeaderOne":"base-layout_signupHeaderOne__LFpTs"};